import { memo } from 'react';

const FreemiumStar = () => <i className="material-icons freemiumStar__icon">stars</i>;

export default memo(FreemiumStar);
